import React from 'react';
import {
  CircularProgress,
  DatePicker,
  Icon,
  IconButton,
  LinearGradient,
  Pressable,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import {
  ActivityIndicator,
  Image,
  Modal,
  Platform,
  StatusBar,
  Text,
  View,
} from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import ScenarioBlock from '../components/ScenarioBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import * as BarChart from '../custom-files/BarChart';
import * as BarChartMobile from '../custom-files/BarChartMobile';
import * as PieChart from '../custom-files/PieChart';
import * as icon from '../custom-files/icon';
import calculateAverage from '../global-functions/calculateAverage';
import calculateCashOnHandFlow from '../global-functions/calculateCashOnHandFlow';
import checkScreenMode from '../global-functions/checkScreenMode';
import formatNumber from '../global-functions/formatNumber';
import formatPercentage from '../global-functions/formatPercentage';
import generateDates from '../global-functions/generateDates';
import newFormatDate from '../global-functions/newFormatDate';
import timestampToISO from '../global-functions/timestampToISO';
import total from '../global-functions/total';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { total: null };

const DashboardScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [allCategoriesFinance, setAllCategoriesFinance] = React.useState([]);
  const [allCategoriesOperating, setAllCategoriesOperating] = React.useState(
    []
  );
  const [allCategoriesOther, setAllCategoriesOther] = React.useState([]);
  const [allCategoriesPayment, setAllCategoriesPayment] = React.useState('');
  const [datePicker, setDatePicker] = React.useState(new Date());
  const [expenses, setExpenses] = React.useState([]);
  const [financeExpenses, setFinanceExpenses] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [incomeCategories, setIncomeCategories] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [monthlyStartingBalance, setMonthlyStartingBalance] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [numberInputsFinance, setNumberInputsFinance] = React.useState([]);
  const [numberInputsIncome, setNumberInputsIncome] = React.useState('');
  const [numberInputsOperating, setNumberInputsOperating] = React.useState([]);
  const [numberInputsOther, setNumberInputsOther] = React.useState([]);
  const [numberInputsPaymentForCost, setNumberInputsPaymentForCost] =
    React.useState([]);
  const [operatingExpenses, setOperatingExpenses] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [payrollExpenses, setPayrollExpenses] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [pickerValue, setPickerValue] = React.useState('');
  const [productPaymentCosts, setProductPaymentCosts] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [selectedMonth, setSelectedMonth] = React.useState('');
  const [startingCash, setStartingCash] = React.useState(0);
  const [startingDate, setStartingDate] = React.useState(new Date());
  const [staticCartValues, setStaticCartValues] = React.useState([
    '$0.00',
    '$100,000.00',
    '$200,000.00',
    '$300,000.00',
    '$400,000.00',
    '$500,000.00',
    '$600,000.00',
    '$700,000.00',
  ]);
  const [staticValues, setStaticValues] = React.useState({});
  const [totalCashAvailable, setTotalCashAvailable] = React.useState('');
  const [totalCashOnHand, setTotalCashOnHand] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalCashPaid, setTotalCashPaid] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalCashPaidOut, setTotalCashPaidOut] = React.useState([]);
  const [totalFinancePerCategory, setTotalFinancePerCategory] = React.useState(
    []
  );
  const [totalFinancePerMonth, setTotalFinancePerMonth] = React.useState([]);
  const [totalIncome, setTotalIncome] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalIncomePerCategory, setTotalIncomePerCategory] =
    React.useState('');
  const [totalIncomePerMonth, setTotalIncomePerMonth] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalOperatingPerCategory, setTotalOperatingPerCategory] =
    React.useState([]);
  const [totalOperatingPerMonth, setTotalOperatingPerMonth] = React.useState(
    []
  );
  const [totalOtherPerCategory, setTotalOtherPerCategory] = React.useState([]);
  const [totalPaymentForCostPerCetagory, setTotalPaymentForCostPerCetagory] =
    React.useState([]);
  const [totalPaymentForCostPerMonth, setTotalPaymentForCostPerMonth] =
    React.useState([]);
  const [visibleWhatIf, setVisibleWhatIf] = React.useState(false);
  const calculateCashOnHand = (
    totalIncome,
    totalCashPaid,
    startingCash,
    previousValue
  ) => {
    const length = totalIncome?.length || 12;
    const totalIncomeArr = totalIncome || Array(12).fill(0);
    const totalCashPaidArr = totalCashPaid || Array(12).fill(0);
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      result[i] = (totalIncomeArr[i] || 0) - (totalCashPaidArr[i] || 0);
    }

    const previosMonthlValue = (startingCash || 0) + (previousValue || 0);

    return [previosMonthlValue, ...result];
  };

  const calculateEndingBalance = data => {
    const startingBalance = data.starting_balance?.amount || 0;
    const incomeAmount = data.income?.[0]?.monthly_income_amount || 0;
    const totalExpenses =
      data.total_expenses?.[0]?.monthly_expenses_amount || 0;

    return startingBalance + incomeAmount - totalExpenses;
  };

  const calculateEndingProfit = (totalIncome, totalCashPaidOut) => {
    const sumTotalIncome = totalIncome.reduce((acc, value) => acc + value, 0);
    const sumTotalCashPaidOut = totalCashPaidOut.reduce(
      (acc, value) => acc + value,
      0
    );

    const netIncome = sumTotalIncome - sumTotalCashPaidOut;
    return netIncome;
  };

  const calculateForPieChart = (
    productExpense,
    financeExpense,
    operatingExpense,
    payrollExpense
  ) => {
    const calculateTotal = expenseArray => {
      if (!Array.isArray(expenseArray)) {
        //console.error("Expected an array, but received:", expenseArray);
        return 0;
      }
      return expenseArray.reduce((acc, val) => acc + (val || 0), 0);
    };

    const totalProductExpense = calculateTotal(productExpense);
    const totalFinanceExpense = calculateTotal(financeExpense);
    const totalOperatingExpense = calculateTotal(operatingExpense);
    const totalPayrollExpense = calculateTotal(payrollExpense);

    const totalExpenses =
      totalProductExpense +
      totalFinanceExpense +
      totalOperatingExpense +
      totalPayrollExpense;

    let data = [
      {
        name: 'Finance Expense',
        value: (totalFinanceExpense / totalExpenses) * 100,
      },
      {
        name: 'Operating Expense',
        value: (totalOperatingExpense / totalExpenses) * 100,
      },
      {
        name: 'Employee Expense',
        value: (totalPayrollExpense / totalExpenses) * 100,
      },
      {
        name: 'Product Expense',
        value: (totalProductExpense / totalExpenses) * 100,
      },
    ];

    data = data.map(item => ({
      name: item.name,
      value: Math.round(item.value),
    }));

    const totalRounded = data.reduce((acc, item) => acc + item.value, 0);
    const difference = 100 - totalRounded;

    if (difference !== 0) {
      const maxIndex = data.reduce(
        (maxIdx, item, idx, arr) =>
          item.value > arr[maxIdx].value ? idx : maxIdx,
        0
      );
      data[maxIndex].value += difference;
    }

    return data;
  };

  const compareMonths = (startingDate, selectedMonth) => {
    const start = new Date(startingDate);
    const selected = new Date(selectedMonth);

    const isSameMonthAndYear =
      start.getMonth() === selected.getMonth() &&
      start.getFullYear() === selected.getFullYear();

    return isSameMonthAndYear;
  };

  const extractAmounts = (category, type, startingDate) => {
    // if (type === 'total_income') {
    //   let result = category.map(item => item.monthly_income_amount);

    //   while (result.length < 12) {
    //     result.push(0);
    //   }

    //   return result;
    // }

    // else if (type === 'total_cash_paid_out') {
    //   let result = category.map(item => item.monthly_expenses_amount);

    //   while (result.length < 12) {
    //     result.push(0);
    //   }
    // console.log("result cash paid out:",result)
    //   return result;
    // }

    // else {
    //   let result = category.map(item => item.amount);

    //   while (result.length < 12) {
    //     result.push(0);
    //   }
    // console.log("result function category:",result)
    //   return result;
    // }

    //we were extracting values by index, it was creating an isssue when we go back to previous month. I updated the function for pushing correct value for each month

    // const STARTING_DATE = startingDate;
    // const MONTHS_IN_YEAR = 12;

    // function getMonthIndex(timestamp) {
    //   const startDate = new Date(STARTING_DATE);
    //   const currentDate = new Date(timestamp);

    //   const startYear = startDate.getUTCFullYear();
    //   const startMonth = startDate.getUTCMonth();
    //   const currentYear = currentDate.getUTCFullYear();
    //   const currentMonth = currentDate.getUTCMonth();

    //   return (
    //     (currentYear - startYear) * 12 +
    //     currentMonth - startMonth
    //   );
    // }

    // let result = new Array(MONTHS_IN_YEAR).fill(0);

    // if (type === 'total_income') {
    //   result = category.map(item => item.monthly_income_amount);
    //   while (result.length < 12) {
    //     result.push(0);
    //   }
    //   return result;
    // } else if (type === "total_cash_paid_out") {
    //   category.forEach(item => {
    //     const monthIndex = getMonthIndex(item.monthly_expenses_month);
    //     if (monthIndex >= 0 && monthIndex < MONTHS_IN_YEAR) {
    //       result[monthIndex] = item.monthly_expenses_amount;
    //     }
    //   });
    // } else {
    //   category.forEach(item => {
    //     const monthIndex = getMonthIndex(item.month);
    //     if (monthIndex >= 0 && monthIndex < MONTHS_IN_YEAR) {
    //       result[monthIndex] = item.amount;
    //     }
    //   });
    // }

    // return result

    //3rd try
    const STARTING_DATE = startingDate;
    const MONTHS_IN_YEAR = 12;

    // Month-year formatını normalize eden yardımcı fonksiyon
    function parseMonthYear(monthYear) {
      const [monthName, year] = monthYear.split(', ');
      const months = {
        January: 0,
        February: 1,
        March: 2,
        April: 3,
        May: 4,
        June: 5,
        July: 6,
        August: 7,
        September: 8,
        October: 9,
        November: 10,
        December: 11,
      };

      return { year: parseInt(year, 10), month: months[monthName] };
    }

    function getMonthIndex(timestamp) {
      const startDate = new Date(STARTING_DATE);
      const currentDate = new Date(timestamp);

      const startYear = startDate.getUTCFullYear();
      const startMonth = startDate.getUTCMonth();
      const currentYear = currentDate.getUTCFullYear();
      const currentMonth = currentDate.getUTCMonth();

      return (currentYear - startYear) * 12 + (currentMonth - startMonth);
    }

    function getMonthIndexString(monthYear) {
      const { year, month } = parseMonthYear(monthYear);
      const startDate = new Date(STARTING_DATE);

      const startYear = startDate.getUTCFullYear();
      const startMonth = startDate.getUTCMonth();

      return (year - startYear) * 12 + (month - startMonth);
    }

    let result = new Array(MONTHS_IN_YEAR).fill(0);

    if (type === 'total_income') {
      result = category.map(item => item.monthly_income_amount);
      while (result.length < 12) {
        result.push(0);
      }
      return result;
    } else if (type === 'total_cash_paid_out') {
      category.forEach(item => {
        const monthIndex = getMonthIndex(item.monthly_expenses_month);
        if (monthIndex >= 0 && monthIndex < MONTHS_IN_YEAR) {
          result[monthIndex] = item.monthly_expenses_amount;
        }
      });
    } else if (
      type === 'operating_expenses' ||
      type === 'payroll_expenses' ||
      type === 'finance_expenses'
    ) {
      category.forEach(item => {
        const monthIndex = getMonthIndexString(item.month);
        if (monthIndex >= 0 && monthIndex < MONTHS_IN_YEAR) {
          result[monthIndex] = item.amount;
        }
      });
    } else {
      category.forEach(item => {
        const monthIndex = getMonthIndex(item.month);
        if (monthIndex >= 0 && monthIndex < MONTHS_IN_YEAR) {
          result[monthIndex] = item.amount;
        }
      });
    }

    return result;
  };

  const findMonthlyAmount = (startingDate, selectedMonth, numberArr) => {
    console.log('startingdate:', startingDate);
    console.log('selectedMonth:', selectedMonth);
    console.log('numberArr:', numberArr);

    const start = new Date(startingDate);
    const selected = new Date(selectedMonth);

    const yearDifference = selected.getFullYear() - start.getFullYear();
    const monthDifference = selected.getMonth() - start.getMonth();

    const totalMonthDifference = yearDifference * 12 + monthDifference;

    const valueIndex = totalMonthDifference;

    console.log('return:', numberArr[valueIndex]);
    if (valueIndex >= 0 && valueIndex < numberArr.length) {
      return numberArr[valueIndex];
    } else {
      return null;
    }

    // console.log("Starting Date (Raw):", startingDate);
    // console.log("Selected Month (Raw):", selectedMonth);

    // // Tarih objelerini oluştur
    // const start = new Date(startingDate);
    // const selected = new Date(selectedMonth);

    // console.log("Parsed Starting Date:", start);
    // console.log("Parsed Selected Month:", selected);

    // // Ay farkını hesapla
    // const yearDifference = selected.getFullYear() - start.getFullYear();
    // const monthDifference = selected.getMonth() - start.getMonth();

    // // Toplam ay farkını bul
    // const totalMonthDifference = (yearDifference * 12) + monthDifference;

    // console.log("Year Difference:", yearDifference);
    // console.log("Month Difference:", monthDifference);
    // console.log("Total Month Difference (valueIndex):", totalMonthDifference);

    // // Dizinin sınırları içinde olup olmadığını kontrol et
    // if (totalMonthDifference >= 0 && totalMonthDifference < numberArr.length) {
    //     console.log("Return Value:", numberArr[totalMonthDifference]);
    //     return numberArr[totalMonthDifference];
    // } else {
    //     console.warn("Selected month is out of the range of numberArr.");
    //     return null;
    // }
  };

  const findStartingBalance = (startingDate, totalCashPaid, selectedMonth) => {
    const start = new Date(startingDate);
    const selected = new Date(selectedMonth);

    const yearDifference = selected.getFullYear() - start.getFullYear();
    const monthDifference = selected.getMonth() - start.getMonth();

    const totalMonthDifference = yearDifference * 12 + monthDifference;

    const cashPaidIndex = totalMonthDifference - 1;

    if (cashPaidIndex >= 0 && cashPaidIndex < totalCashPaid.length) {
      return totalCashPaid[cashPaidIndex];
    } else {
      return null;
    }
  };

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const getValueByMonth = (valuesArray, startingDate, selectedMonth) => {
    const start = new Date(startingDate);
    const selected = new Date(selectedMonth);

    const monthDiff =
      (selected.getFullYear() - start.getFullYear()) * 12 +
      (selected.getMonth() - start.getMonth());

    if (monthDiff < 0 || monthDiff >= valuesArray.length) {
      return null;
    }
    return valuesArray[monthDiff];
  };

  const listCurrentYearMonths = () => {
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let months = [];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let month = 0; month < 12; month++) {
      months.push(`${monthNames[month]} ${currentYear}`);
    }

    // "Ending Balance" ve "Expense" stringlerini ekle
    months.push('Ending Balance', 'Expense');

    return months;
  };

  const pullStartingBalance = (data, startingDate) => {
    const result = [];

    let currentDate = new Date(startingDate);
    currentDate.setUTCDate(1);

    for (let i = 0; i < 12; i++) {
      const matchingRecord = data.find(record => {
        const recordDate = new Date(record.month);
        return (
          recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
          recordDate.getUTCMonth() === currentDate.getUTCMonth()
        );
      });

      if (matchingRecord) {
        result.push(matchingRecord.amount);
      } else {
        result.push(0);
      }

      currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
    }

    return result;
  };
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }

      const entry = StatusBar.pushStackEntry?.({ barStyle: 'light-content' });
      return () => StatusBar.popStackEntry?.(entry);
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        { backgroundColor: palettes.Brand.Background },
        dimensions.width
      )}
    >
      <DefaultApi.FetchDashboardDataGET
        handlers={{
          onData: fetchData => {
            try {
              /* hidden 'Set Variable' action */
              /* hidden 'Set Variable' action */
              /* hidden 'Log to Console' action */
              const totalIncomeREs = (() => {
                if (fetchData?.total_income?.length > 0) {
                  return setGlobalVariableValue({
                    key: 'TOTAL_INCOME',
                    value: extractAmounts(
                      fetchData?.total_income,
                      'total_income',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              const totalCashPaidRes = (() => {
                if (fetchData?.total_cash_paid_out?.length > 0) {
                  return setGlobalVariableValue({
                    key: 'TOTAL_CASH_PAID',
                    value: extractAmounts(
                      fetchData?.total_cash_paid_out,
                      'total_cash_paid_out',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              /* hidden 'Set Variable' action */
              /* hidden 'Set Variable' action */
              const starting_balance = (() => {
                if (fetchData?.cash_at_hand?.[0]?.month) {
                  return setGlobalVariableValue({
                    key: 'CASH_ON_HAND',
                    value: pullStartingBalance(
                      fetchData?.cash_at_hand,
                      Constants['STARTING_DATE']
                    ).concat([
                      (pullStartingBalance(
                        fetchData?.cash_at_hand,
                        Constants['STARTING_DATE']
                      ) &&
                        pullStartingBalance(
                          fetchData?.cash_at_hand,
                          Constants['STARTING_DATE']
                        )[11]) +
                        (totalIncomeREs && totalIncomeREs[11]) -
                        (totalCashPaidRes && totalCashPaidRes[11]),
                    ]),
                  });
                }
              })();
              if (starting_balance) {
                setGlobalVariableValue({
                  key: 'TOTAL_CASH_ON_HAND',
                  value: starting_balance.slice(1, 13),
                });
              }
              const startingCashRes = (() => {
                if (starting_balance) {
                  return setGlobalVariableValue({
                    key: 'STARTING_CASH',
                    value: starting_balance && starting_balance[0],
                  });
                }
              })();
              const resCogs = (() => {
                if (fetchData?.cogs?.['default']?.[0]?.data?.[0]?.id) {
                  return setGlobalVariableValue({
                    key: 'PRODUCT_PAYMENT_COSTS',
                    value: extractAmounts(
                      fetchData?.cogs?.['default']?.[0]?.data,
                      'cogs',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              const resFin = (() => {
                if (fetchData?.finance_expenses?.['default']?.length > 0) {
                  return setGlobalVariableValue({
                    key: 'FINANCE_EXPENSES',
                    value: extractAmounts(
                      fetchData?.finance_expenses?.default,
                      'finance_expenses',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              const resOpr = (() => {
                if (fetchData?.operating_expenses?.['default']?.length > 0) {
                  return setGlobalVariableValue({
                    key: 'OPERATING_EXPENSES',
                    value: extractAmounts(
                      fetchData?.operating_expenses?.default,
                      'operating_expenses',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              const resPayroll = (() => {
                if (fetchData?.payroll_expenses?.default?.length > 0) {
                  return setGlobalVariableValue({
                    key: 'PAYROLL_EXPENSES',
                    value: extractAmounts(
                      fetchData?.payroll_expenses?.default,
                      'payroll_expenses',
                      Constants['STARTING_DATE']
                    ),
                  });
                }
              })();
              if (resOpr) {
                const test = setGlobalVariableValue({
                  key: 'EXPENSES',
                  value: calculateForPieChart(
                    resCogs,
                    resFin,
                    resOpr,
                    resPayroll
                  ),
                });
              } else {
                setGlobalVariableValue({
                  key: 'EXPENSES',
                  value: '',
                });
              }

              /* hidden 'Set Variable' action */
            } catch (err) {
              console.error(err);
            }
          },
        }}
        startin_date={
          Constants['STARTING_DATE']
            ? Constants['STARTING_DATE']
            : newFormatDate(new Date(), 'get')
        }
      >
        {({ loading, error, data, refetchDashboardData }) => {
          const fetchData = data?.json;
          if (loading) {
            return (
              <>
                {/* isLoading View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: [
                        { minWidth: Breakpoints.Laptop, value: 'center' },
                        { minWidth: Breakpoints.Mobile, value: 'center' },
                      ],
                      backgroundColor: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['Black %50'],
                      },
                      flex: [
                        { minWidth: Breakpoints.Laptop, value: 1 },
                        { minWidth: Breakpoints.Mobile, value: 1 },
                      ],
                      gap: 10,
                      justifyContent: [
                        { minWidth: Breakpoints.Laptop, value: 'center' },
                        { minWidth: Breakpoints.Mobile, value: 'center' },
                      ],
                    },
                    dimensions.width
                  )}
                >
                  <ActivityIndicator
                    animating={true}
                    hidesWhenStopped={true}
                    {...GlobalStyles.ActivityIndicatorStyles(theme)[
                      'Activity Indicator'
                    ].props}
                    size={'large'}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.ActivityIndicatorStyles(theme)[
                          'Activity Indicator'
                        ].style,
                        {
                          height: { minWidth: Breakpoints.Laptop, value: 100 },
                          width: { minWidth: Breakpoints.Laptop, value: 100 },
                        }
                      ),
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Header'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Header'].style,
                        {
                          color: palettes.Brand.White,
                          fontSize: [
                            { minWidth: Breakpoints.Laptop, value: 20 },
                            { minWidth: Breakpoints.Mobile, value: 20 },
                          ],
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {'Loading, please wait...'}
                  </Text>
                </View>
              </>
            );
          }

          if (error || data?.status < 200 || data?.status >= 300) {
            return <ActivityIndicator />;
          }

          return (
            <>
              {/* Container - Web */}
              <>
                {!(dimensions.width >= Breakpoints.Laptop) ? null : (
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flex: [
                          { minWidth: Breakpoints.Laptop, value: 1 },
                          { minWidth: Breakpoints.Desktop, value: 1 },
                        ],
                        flexDirection: [
                          { minWidth: Breakpoints.Laptop, value: 'row' },
                          { minWidth: Breakpoints.Desktop, value: 'row' },
                        ],
                        maxHeight: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.height,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <SideMenuBlock
                      screen={'dashboard'}
                      setToggleWhatIf={toggleWhatIf =>
                        setVisibleWhatIf(toggleWhatIf)
                      }
                      toggleWhatIf={visibleWhatIf}
                    />
                    {/* Dashboard Scroll View */}
                    <SimpleStyleScrollView
                      bounces={true}
                      horizontal={false}
                      keyboardShouldPersistTaps={'never'}
                      nestedScrollEnabled={false}
                      showsHorizontalScrollIndicator={true}
                      showsVerticalScrollIndicator={true}
                      style={StyleSheet.applyWidth(
                        {
                          flex: { minWidth: Breakpoints.Laptop, value: 1 },
                          gap: { minWidth: Breakpoints.Laptop, value: 20 },
                          justifyContent: [
                            {
                              minWidth: Breakpoints.Laptop,
                              value: 'flex-start',
                            },
                            {
                              minWidth: Breakpoints.BigScreen,
                              value: 'flex-start',
                            },
                          ],
                          padding: { minWidth: Breakpoints.Laptop, value: 12 },
                        },
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignSelf: {
                              minWidth: Breakpoints.Laptop,
                              value: 'flex-end',
                            },
                            backgroundColor: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            borderRadius: {
                              minWidth: Breakpoints.Laptop,
                              value: 50,
                            },
                            padding: { minWidth: Breakpoints.Laptop, value: 3 },
                          },
                          dimensions.width
                        )}
                      >
                        <IconButton
                          onPress={() => {
                            try {
                              navigation.navigate('BestPracticesScreen');
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          size={32}
                          color={StyleSheet.getWidthValue(
                            [
                              {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.Brand.Black,
                              },
                            ],
                            dimensions.width
                          )}
                          icon={'MaterialIcons/question-mark'}
                          size={StyleSheet.getWidthValue(
                            [{ minWidth: Breakpoints.Laptop, value: 20 }],
                            dimensions.width
                          )}
                        />
                      </View>
                      {/* Top */}
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            flexDirection: {
                              minWidth: Breakpoints.Laptop,
                              value: 'row',
                            },
                            gap: { minWidth: Breakpoints.Laptop, value: 24 },
                            paddingTop: {
                              minWidth: Breakpoints.Laptop,
                              value: 30,
                            },
                          },
                          dimensions.width
                        )}
                      >
                        {/* Left */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              backgroundColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.Brand.White,
                              },
                              borderColor: [
                                {
                                  minWidth: Breakpoints.Laptop,
                                  value: palettes.Brand['App Blue Dark'],
                                },
                                {
                                  minWidth: Breakpoints.Desktop,
                                  value: palettes.App['App Blue Light'],
                                },
                              ],
                              borderWidth: [
                                { minWidth: Breakpoints.Desktop, value: 3 },
                                { minWidth: Breakpoints.Laptop, value: 3 },
                              ],
                              flex: [
                                { minWidth: Breakpoints.Desktop, value: 1 },
                                { minWidth: Breakpoints.Laptop, value: 1.2 },
                              ],
                              gap: [
                                { minWidth: Breakpoints.Desktop, value: 8 },
                                { minWidth: Breakpoints.Laptop, value: 8 },
                              ],
                              paddingTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 12,
                              },
                            },
                            dimensions.width
                          )}
                        >
                          {/* Chart Elements */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flexWrap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'wrap',
                                },
                                paddingLeft: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 6,
                                },
                                paddingRight: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 6,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Top */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-around',
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Product Payment Costs */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                    ],
                                    flexDirection: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'row',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                    ],
                                    gap: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 2,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                    ],
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.Brand['App Yellow']}
                                  name={'FontAwesome/circle'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        fontFamily: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_600SemiBold',
                                        },
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 12,
                                          },
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 14,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 16,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Product Expense'}
                                </Text>
                              </View>
                              {/* Finance */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    ],
                                    flexDirection: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'row',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                    ],
                                    gap: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 2,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                    ],
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.App['App Cobalt']}
                                  name={'FontAwesome/circle'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        fontFamily: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_600SemiBold',
                                        },
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 12,
                                          },
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 14,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 16,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Finance Expense'}
                                </Text>
                              </View>
                            </View>
                            {/* Bottom */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-around',
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Operating Expanses */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    ],
                                    flexDirection: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'row',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                    ],
                                    gap: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 2,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                    ],
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.Brand['App Green']}
                                  name={'FontAwesome/circle'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        fontFamily: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_600SemiBold',
                                        },
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 12,
                                          },
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 14,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 16,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Operating Expense'}
                                </Text>
                              </View>
                              {/* Employee Expenses */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                    ],
                                    flexDirection: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'row',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                    ],
                                    gap: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 2,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                    ],
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.Brand['App Blue Dark']}
                                  name={'FontAwesome/circle'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        fontFamily: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_600SemiBold',
                                        },
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 12,
                                          },
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 14,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 16,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Employee Expense'}
                                </Text>
                              </View>
                            </View>
                          </View>
                          {/* Pie Chart */}
                          <>
                            {!Constants['EXPENSES'] ? null : (
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    ],
                                    flex: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    justifyContent: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 'center',
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    ],
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Pie Chart Custom Code */}
                                <Utils.CustomCodeErrorBoundary>
                                  <PieChart.Pie />
                                </Utils.CustomCodeErrorBoundary>
                                {/* Icons of Pie Chart */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      position: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'absolute',
                                      },
                                      zIndex: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 100,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Custom Code 2 */}
                                  <Utils.CustomCodeErrorBoundary>
                                    <icon.IconCircle />
                                  </Utils.CustomCodeErrorBoundary>
                                </View>
                              </View>
                            )}
                          </>
                          {/* Empty Chart */}
                          <>
                            {Constants['EXPENSES'] ? null : (
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    flex: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 10,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <CircularProgress
                                  animationDuration={500}
                                  indeterminate={false}
                                  lineCap={'round'}
                                  showTrack={true}
                                  startPosition={'top'}
                                  trackColor={theme.colors.border.base}
                                  trackLineCap={'round'}
                                  color={palettes.App['Gray Linear Light']}
                                  isAnimated={false}
                                  maximumValue={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignSelf: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      opacity: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0.5,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: '70%',
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: '55%',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: '90%',
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                  thickness={35}
                                  value={100}
                                />
                              </View>
                            )}
                          </>
                        </View>
                        {/* Right */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              flex: [
                                { minWidth: Breakpoints.Desktop, value: 2 },
                                { minWidth: Breakpoints.Laptop, value: 2 },
                              ],
                              gap: [
                                { minWidth: Breakpoints.Laptop, value: 10 },
                                { minWidth: Breakpoints.Desktop, value: 20 },
                              ],
                              justifyContent: {
                                minWidth: Breakpoints.Laptop,
                                value: 'space-between',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          {/* Top */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flex: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 1,
                                },
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                gap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 20,
                                },
                                justifyContent: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'space-between',
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Starting Balance View */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  GlobalStyles.TextStyles(theme)['Widgets']
                                    .style,
                                  dimensions.width
                                )}
                              >
                                {'Starting Balance'}
                              </Text>
                              <Image
                                resizeMode={'cover'}
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                source={imageSource(Images['startingbalance'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(Constants['STARTING_CASH'])}
                              </Text>
                            </View>
                            {/* Avg.Monthly Payroll */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Avg. Monthly'}
                              </Text>
                              {/* Head 2 */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      marginTop: {
                                        minWidth: Breakpoints.Laptop,
                                        value: -6,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Employee Expense'}
                              </Text>
                              <Image
                                resizeMode={'cover'}
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                source={imageSource(Images['payrol'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(
                                  calculateAverage(
                                    Constants['PAYROLL_EXPENSES']
                                  )
                                )}
                              </Text>
                            </View>
                            {/* Avg. Monthly Operating Expense */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Avg. Monthly'}
                              </Text>
                              {/* Head 2 */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      marginTop: {
                                        minWidth: Breakpoints.Laptop,
                                        value: -6,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Operating Expense'}
                              </Text>
                              <Image
                                resizeMode={'cover'}
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                source={imageSource(Images['operating'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(
                                  calculateAverage(
                                    Constants['OPERATING_EXPENSES']
                                  )
                                )}
                              </Text>
                            </View>
                          </View>
                          {/* Bottom */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flex: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 1,
                                },
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                gap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 20,
                                },
                                justifyContent: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'space-between',
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Ending Balance View */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Ending Balance'}
                              </Text>
                              <Image
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                resizeMode={'contain'}
                                source={imageSource(Images['endingbalance'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(
                                  Constants['TOTAL_CASH_ON_HAND'] &&
                                    Constants['TOTAL_CASH_ON_HAND'][11]
                                )}
                              </Text>
                            </View>
                            {/* Avg.Monthly Product Cost */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Avg. Monthly'}
                              </Text>
                              {/* Head 2 */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      marginTop: {
                                        minWidth: Breakpoints.Laptop,
                                        value: -6,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Product Cost'}
                              </Text>
                              <Image
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                resizeMode={'contain'}
                                source={imageSource(Images['product'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(
                                  calculateAverage(
                                    Constants['PRODUCT_PAYMENT_COSTS']
                                  )
                                )}
                              </Text>
                            </View>
                            {/* Ending Profit */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.White,
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderRadius: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 12,
                                    },
                                    { minWidth: Breakpoints.Laptop, value: 12 },
                                  ],
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'space-between',
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Head */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Widgets']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Widgets']
                                      .style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Ending Profit'}
                              </Text>
                              <Image
                                {...GlobalStyles.ImageStyles(theme)['Image']
                                  .props}
                                resizeMode={'contain'}
                                source={imageSource(Images['endingprofit'])}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.ImageStyles(theme)['Image']
                                      .style,
                                    {
                                      height: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 50,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 60,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              />
                              {/* Values */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                      ],
                                      fontFamily: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'OpenSans_500Medium',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_500Medium',
                                        },
                                      ],
                                      fontSize: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 28,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'$'}
                                {formatNumber(
                                  calculateEndingProfit(
                                    Constants['TOTAL_INCOME'],
                                    Constants['TOTAL_CASH_PAID']
                                  )
                                )}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>
                      {/* Bar/Line Chart */}
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            borderColor: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            borderWidth: {
                              minWidth: Breakpoints.Laptop,
                              value: 3,
                            },
                          },
                          dimensions.width
                        )}
                      >
                        <LinearGradient
                          endX={100}
                          endY={100}
                          startX={0}
                          startY={0}
                          color1={StyleSheet.getWidthValue(
                            [
                              {
                                minWidth: Breakpoints.Mobile,
                                value: palettes.App['Gray Linear Light'],
                              },
                              {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['Background Light'],
                              },
                            ],
                            dimensions.width
                          )}
                          color2={StyleSheet.getWidthValue(
                            [
                              {
                                minWidth: Breakpoints.Mobile,
                                value: palettes.App['Gray Linear Dark'],
                              },
                              {
                                minWidth: Breakpoints.Laptop,
                                value: theme.colors.background.brand,
                              },
                            ],
                            dimensions.width
                          )}
                          color3={StyleSheet.getWidthValue(
                            [
                              {
                                minWidth: Breakpoints.Mobile,
                                value: palettes.App['Gray Linear Light'],
                              },
                              {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['Background Light'],
                              },
                            ],
                            dimensions.width
                          )}
                          style={StyleSheet.applyWidth(
                            {
                              bottom: {
                                minWidth: Breakpoints.Laptop,
                                value: 0,
                              },
                              flex: { minWidth: Breakpoints.Laptop, value: 1 },
                              left: { minWidth: Breakpoints.Laptop, value: 0 },
                              position: {
                                minWidth: Breakpoints.Laptop,
                                value: 'absolute',
                              },
                              right: { minWidth: Breakpoints.Laptop, value: 0 },
                              top: { minWidth: Breakpoints.Laptop, value: 0 },
                            },
                            dimensions.width
                          )}
                        />
                        {/* Header */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              alignSelf: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              backgroundColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.Brand['App Blue Dark'],
                              },
                              borderColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['Gray Linear Light'],
                              },
                              borderWidth: {
                                minWidth: Breakpoints.Laptop,
                                value: 3,
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              marginTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 5,
                              },
                              padding: {
                                minWidth: Breakpoints.Laptop,
                                value: 4,
                              },
                              position: {
                                minWidth: Breakpoints.Laptop,
                                value: 'absolute',
                              },
                              zIndex: {
                                minWidth: Breakpoints.Laptop,
                                value: 5,
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <LinearGradient
                            color1={theme.colors.branding.primary}
                            color2={theme.colors.branding.secondary}
                            endY={100}
                            startX={0}
                            startY={0}
                            {...GlobalStyles.LinearGradientStyles(theme)[
                              'Blue Linear'
                            ].props}
                            endX={0}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.LinearGradientStyles(theme)[
                                  'Blue Linear'
                                ].style,
                                {
                                  paddingBottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                  paddingTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            {/* Header Text */}
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    color: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    fontFamily: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'OpenSans_700Bold',
                                    },
                                    fontSize: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {'Cash On hand vs. Expenses'}
                            </Text>
                          </LinearGradient>
                        </View>

                        <View
                          style={StyleSheet.applyWidth(
                            {
                              flexDirection: {
                                minWidth: Breakpoints.Laptop,
                                value: 'row',
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                width: {
                                  minWidth: Breakpoints.Laptop,
                                  value: '95%',
                                },
                              },
                              dimensions.width
                            )}
                          >
                            <Utils.CustomCodeErrorBoundary>
                              <BarChart.App />
                            </Utils.CustomCodeErrorBoundary>
                          </View>
                          {/* Chart Materials View */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignItems: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'center',
                                },
                                gap: { minWidth: Breakpoints.Laptop, value: 6 },
                                height: {
                                  minWidth: Breakpoints.Laptop,
                                  value: '100%',
                                },
                                justifyContent: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'center',
                                },
                                position: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'absolute',
                                },
                                right: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 0,
                                },
                                width: [
                                  { minWidth: Breakpoints.Laptop, value: '8%' },
                                  {
                                    minWidth: Breakpoints.Desktop,
                                    value: '6%',
                                  },
                                  {
                                    minWidth: Breakpoints.BigScreen,
                                    value: '5%',
                                  },
                                ],
                              },
                              dimensions.width
                            )}
                          >
                            {/* Total Cash Paid Out */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  width: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '100%',
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Icon
                                color={palettes.Brand['App Blue Dark']}
                                name={'Ionicons/square-sharp'}
                                size={14}
                              />
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: '"rgb(255, 255, 255)"',
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'left',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Total Cash Paid Out'}
                              </Text>
                            </View>
                            {/* Cash on hand */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  width: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '100%',
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Icon
                                color={palettes.Brand['App Green']}
                                name={'Ionicons/square-sharp'}
                                size={14}
                              />
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: '"rgb(255, 255, 255)"',
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'left',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Cash on hand (end of month)'}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>

                      <SimpleStyleScrollView
                        bounces={true}
                        keyboardShouldPersistTaps={'never'}
                        nestedScrollEnabled={false}
                        showsHorizontalScrollIndicator={true}
                        showsVerticalScrollIndicator={true}
                        horizontal={true}
                        style={StyleSheet.applyWidth(
                          {
                            backgroundColor: {
                              minWidth: Breakpoints.Laptop,
                              value: checkScreenMode(Variables)
                                ? undefined
                                : palettes.Brand.White,
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            paddingBottom: {
                              minWidth: Breakpoints.Laptop,
                              value: 25,
                            },
                          },
                          dimensions.width
                        )}
                      >
                        {/* Table */}
                        <View>
                          {/* Header 1 */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                height: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 25,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Month */}
                            <LinearGradient
                              color1={theme.colors.branding.primary}
                              color2={theme.colors.branding.secondary}
                              endY={100}
                              startX={0}
                              startY={0}
                              {...GlobalStyles.LinearGradientStyles(theme)[
                                'Blue Linear'
                              ].props}
                              endX={0}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.LinearGradientStyles(theme)[
                                    'Blue Linear'
                                  ].style,
                                  {
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.White,
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'flex-end',
                                    },
                                    maxWidth: [
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                    ],
                                    minWidth: [
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                    ],
                                    width: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                    ],
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {/* Month */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Chart Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Chart Text']
                                      .style,
                                    {
                                      paddingRight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 4,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Month'}
                              </Text>
                            </LinearGradient>
                            {/* Header 1 List */}
                            <SimpleStyleFlatList
                              data={generateDates(
                                Constants['STARTING_DATE']
                                  ? Constants['STARTING_DATE']
                                  : new Date()
                              )
                                .concat('Ending Balance/Total')
                                .concat('Expense')}
                              decelerationRate={'normal'}
                              inverted={false}
                              keyExtractor={(header1ListData, index) =>
                                header1ListData?.id ??
                                header1ListData?.uuid ??
                                index?.toString() ??
                                JSON.stringify(header1ListData)
                              }
                              keyboardShouldPersistTaps={'never'}
                              listKey={'Zhpo3XVa'}
                              nestedScrollEnabled={false}
                              numColumns={1}
                              onEndReachedThreshold={0.5}
                              pagingEnabled={false}
                              renderItem={({ item, index }) => {
                                const header1ListData = item;
                                return (
                                  <>
                                    {/* Header 1 List Gradient */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Header 1 List Text */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {header1ListData}
                                      </Text>
                                    </LinearGradient>
                                  </>
                                );
                              }}
                              showsVerticalScrollIndicator={true}
                              snapToAlignment={'start'}
                              horizontal={true}
                              scrollEnabled={false}
                              showsHorizontalScrollIndicator={false}
                            />
                          </View>
                          {/* Header 2 */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                height: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 25,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Cash on hand */}
                            <LinearGradient
                              color1={theme.colors.branding.primary}
                              color2={theme.colors.branding.secondary}
                              endY={100}
                              startX={0}
                              startY={0}
                              {...GlobalStyles.LinearGradientStyles(theme)[
                                'Blue Linear'
                              ].props}
                              endX={0}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.LinearGradientStyles(theme)[
                                    'Blue Linear'
                                  ].style,
                                  {
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.White,
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'flex-end',
                                    },
                                    maxWidth: [
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                    ],
                                    minWidth: [
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                    ],
                                    width: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                      {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 200,
                                      },
                                    ],
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {/* Cash on hand */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Chart Text']
                                  .props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Chart Text']
                                      .style,
                                    {
                                      paddingRight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 4,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Cash on hand(beginning of the month)'}
                              </Text>
                            </LinearGradient>
                            {/* Header 2 List */}
                            <SimpleStyleFlatList
                              data={Constants['CASH_ON_HAND'].concat('%Income')}
                              decelerationRate={'normal'}
                              inverted={false}
                              keyExtractor={(header2ListData, index) =>
                                header2ListData?.id ??
                                header2ListData?.uuid ??
                                index?.toString() ??
                                JSON.stringify(header2ListData)
                              }
                              keyboardShouldPersistTaps={'never'}
                              listKey={'JuMhHe5b'}
                              nestedScrollEnabled={false}
                              numColumns={1}
                              onEndReachedThreshold={0.5}
                              pagingEnabled={false}
                              renderItem={({ item, index }) => {
                                const header2ListData = item;
                                return (
                                  <>
                                    {/* Header 2 List Gradient */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            maxHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            minHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: 80,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* $ */}
                                      <>
                                        {!(index <= 12) ? null : (
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              GlobalStyles.TextStyles(theme)[
                                                'Chart Text'
                                              ].style,
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                          </Text>
                                        )}
                                      </>
                                      {/* Header 2 List Text */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {index <= 12
                                          ? formatNumber(header2ListData)
                                          : header2ListData}
                                      </Text>
                                    </LinearGradient>
                                  </>
                                );
                              }}
                              showsHorizontalScrollIndicator={true}
                              showsVerticalScrollIndicator={true}
                              snapToAlignment={'start'}
                              horizontal={false}
                              style={StyleSheet.applyWidth(
                                {
                                  flex: {
                                    minWidth: Breakpoints.Desktop,
                                    value: 1,
                                  },
                                  flexDirection: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 'row',
                                    },
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                  ],
                                  width: {
                                    minWidth: Breakpoints.Desktop,
                                    value: '100%',
                                  },
                                },
                                dimensions.width
                              )}
                            />
                          </View>
                          {/* Bottom Table */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignItems: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'flex-start',
                                },
                                gap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 30,
                                },
                                justifyContent: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'space-between',
                                },
                                paddingTop: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 30,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Table Rows */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: [
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'flex-start',
                                    },
                                    {
                                      minWidth: Breakpoints.BigScreen,
                                      value: 'flex-start',
                                    },
                                  ],
                                  backgroundColor: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value:
                                        Constants['SWITCH_SCREEN_MODE'] ===
                                        false
                                          ? undefined
                                          : palettes.App['Light Linear - Dark'],
                                    },
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value:
                                        Constants['SWITCH_SCREEN_MODE'] ===
                                        false
                                          ? undefined
                                          : palettes.App['Light Linear - Dark'],
                                    },
                                  ],
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.Black,
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 25,
                                  },
                                  width: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '100%',
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Total Income */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      maxHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      maxWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                      minHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      minWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 200,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 200,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Total Income'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['TOTAL_INCOME']
                                    .concat(total(Constants['TOTAL_INCOME']))
                                    .concat('100.00%')}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'HOx8JgiB'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                              {/* Product Payment Costs */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      maxHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      minHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 200,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Product Payment Costs'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['PRODUCT_PAYMENT_COSTS']
                                    .concat(
                                      total(Constants['PRODUCT_PAYMENT_COSTS'])
                                    )
                                    .concat(
                                      formatPercentage(
                                        (total(
                                          Constants['PRODUCT_PAYMENT_COSTS']
                                        ) *
                                          100) /
                                          total(Constants['TOTAL_INCOME'])
                                      )
                                    )}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'hjb0aNLv'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                              {/* Operating Expenses */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      maxHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      minHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 200,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Operating Expenses'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['OPERATING_EXPENSES']
                                    .concat(
                                      total(Constants['OPERATING_EXPENSES'])
                                    )
                                    .concat(
                                      formatPercentage(
                                        (total(
                                          Constants['OPERATING_EXPENSES']
                                        ) *
                                          100) /
                                          total(Constants['TOTAL_INCOME'])
                                      )
                                    )}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'peYNs9Pw'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                              {/* Employee Expenses */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      maxHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      minHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 200,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Employee Expenses'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['PAYROLL_EXPENSES']
                                    .concat(
                                      total(Constants['PAYROLL_EXPENSES'])
                                    )
                                    .concat(
                                      formatPercentage(
                                        (total(Constants['PAYROLL_EXPENSES']) *
                                          100) /
                                          total(Constants['TOTAL_INCOME'])
                                      )
                                    )}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'Rd5DQctm'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                              {/* Finance Expenses */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      maxHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      minHeight: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 25,
                                      },
                                      width: [
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        {
                                          minWidth: Breakpoints.BigScreen,
                                          value: 200,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Finance Expenses'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['FINANCE_EXPENSES']
                                    .concat(
                                      total(Constants['FINANCE_EXPENSES'])
                                    )
                                    .concat(
                                      formatPercentage(
                                        (total(Constants['FINANCE_EXPENSES']) *
                                          100) /
                                          total(Constants['TOTAL_INCOME'])
                                      )
                                    )}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'0FJt7RrO'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                              {/* Total Paid Out */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  {...GlobalStyles.LinearGradientStyles(theme)[
                                    'Inner Gradient'
                                  ].props}
                                  color1={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  color2={
                                    checkScreenMode(Variables)
                                      ? palettes.App['Gray Linear Dark']
                                      : palettes.App['Light Linear - Light']
                                  }
                                  color3={
                                    checkScreenMode(Variables)
                                      ? palettes.Brand.Background
                                      : palettes.App['Light Linear - Dark']
                                  }
                                  endX={100}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.LinearGradientStyles(theme)[
                                        'Inner Gradient'
                                      ].style,
                                      {
                                        borderRightWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 0,
                                        },
                                        borderTopWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 0,
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 24,
                                        },
                                        maxHeight: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 24,
                                        },
                                        maxWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        minHeight: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 24,
                                        },
                                        minWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 200,
                                        },
                                        width: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 200,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 200,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {/* Header Text */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: [
                                            {
                                              minWidth: Breakpoints.Desktop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                Constants[
                                                  'SWITCH_SCREEN_MODE'
                                                ] === false
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                            },
                                          ],
                                          fontSize: {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 12,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Total Paid Out'}
                                  </Text>
                                </LinearGradient>
                                <SimpleStyleFlatList
                                  data={Constants['TOTAL_CASH_PAID']
                                    .concat(total(Constants['TOTAL_CASH_PAID']))
                                    .concat(
                                      formatPercentage(
                                        (total(Constants['TOTAL_CASH_PAID']) *
                                          100) /
                                          total(Constants['TOTAL_INCOME'])
                                      )
                                    )}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(listData, index) =>
                                    listData?.id ??
                                    listData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(listData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'kZidIEzH'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const listData = item;
                                    return (
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            borderColor: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: palettes.Brand.Black,
                                              },
                                            ],
                                            borderLeftWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              {
                                                minWidth: Breakpoints.Desktop,
                                                value: 1,
                                              },
                                            ],
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 90,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 90,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value:
                                                  (dimensions.width -
                                                    dimensions.width *
                                                      (15 / 100) -
                                                    224) /
                                                  14,
                                              },
                                            ],
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color3={
                                            checkScreenMode(Variables)
                                              ? index >= 12
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.Brand.Background
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={100}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              borderRightWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              maxHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: null,
                                              },
                                              maxWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: null,
                                              },
                                              minHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: null,
                                              },
                                              minWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: null,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index <= 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text White'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].style,
                                                    {
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Desktop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ] === false
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: 12,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        Constants[
                                                          'SWITCH_SCREEN_MODE'
                                                        ] === false
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                    },
                                                  ],
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {index <= 12
                                              ? formatNumber(listData)
                                              : listData}
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                    );
                                  }}
                                  showsHorizontalScrollIndicator={true}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                />
                              </View>
                            </View>
                          </View>
                        </View>
                      </SimpleStyleScrollView>
                    </SimpleStyleScrollView>
                  </View>
                )}
              </>
              {/* Container - Mobile */}
              <>
                {!!(dimensions.width >= Breakpoints.Tablet) ? null : (
                  <View
                    style={StyleSheet.applyWidth({ flex: 1 }, dimensions.width)}
                  >
                    <Pressable
                      onPress={() => {
                        try {
                          setSelectedMonth('');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                    >
                      {/* Header */}
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: 'center',
                            backgroundColor: palettes.Brand.Black,
                            flexDirection: 'row',
                            gap: 15,
                            minHeight: 100,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: Platform.OS === 'web' ? 0 : 50,
                          },
                          dimensions.width
                        )}
                      >
                        <Image
                          {...GlobalStyles.ImageStyles(theme)['Image'].props}
                          resizeMode={'contain'}
                          source={imageSource(Images['logo'])}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.ImageStyles(theme)['Image'].style,
                              { height: '100%', width: 90 }
                            ),
                            dimensions.width
                          )}
                        />
                        {/* Image 2 */}
                        <Image
                          {...GlobalStyles.ImageStyles(theme)['Image'].props}
                          resizeMode={'contain'}
                          source={imageSource(Images['logotext'])}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.ImageStyles(theme)['Image'].style,
                              { height: 30, width: '40%' }
                            ),
                            dimensions.width
                          )}
                        />
                      </View>
                    </Pressable>
                    <>
                      {selectedMonth ? null : (
                        <SimpleStyleScrollView
                          bounces={true}
                          horizontal={false}
                          keyboardShouldPersistTaps={'never'}
                          nestedScrollEnabled={false}
                          showsHorizontalScrollIndicator={true}
                          showsVerticalScrollIndicator={true}
                          style={StyleSheet.applyWidth(
                            { flex: 1, gap: 20 },
                            dimensions.width
                          )}
                        >
                          {/* Bar Chart */}
                          <View
                            style={StyleSheet.applyWidth(
                              { flex: 1 },
                              dimensions.width
                            )}
                          >
                            {/* Blue */}
                            <LinearGradient
                              endY={100}
                              startX={0}
                              startY={0}
                              {...GlobalStyles.LinearGradientStyles(theme)[
                                'Linear Gradient'
                              ].props}
                              color1={palettes.Brand['App Blue Dark']}
                              color2={palettes.App['App Blue Light']}
                              color3={palettes.Brand['App Blue Dark']}
                              endX={0}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.LinearGradientStyles(theme)[
                                    'Linear Gradient'
                                  ].style,
                                  {
                                    alignSelf: 'center',
                                    height: 16,
                                    paddingLeft: 6,
                                    paddingRight: 6,
                                    position: 'absolute',
                                    top: 20,
                                    zIndex: 5,
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)['Text']
                                  .props}
                                numberOfLines={1}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)['Text']
                                      .style,
                                    {
                                      color: palettes.Brand.Black,
                                      fontFamily: 'OpenSans_800ExtraBold',
                                      fontSize: 12,
                                      textAlign: 'center',
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Annual Expense Ratios'}
                              </Text>
                            </LinearGradient>
                            <LinearGradient
                              endX={100}
                              startX={0}
                              startY={0}
                              {...GlobalStyles.LinearGradientStyles(theme)[
                                'Linear Gradient'
                              ].props}
                              color1={palettes.App.test}
                              color2={palettes.App['Gray Linear Light']}
                              color3={palettes.App.test}
                              endY={0}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.LinearGradientStyles(theme)[
                                    'Linear Gradient'
                                  ].style,
                                  {
                                    height: [
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: '80%',
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value:
                                          dimensions.width -
                                          dimensions.width * (50 / 100),
                                      },
                                    ],
                                    margin: 15,
                                    opacity: 0.9,
                                    position: 'absolute',
                                    width: [
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: '100%',
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: dimensions.width - 30,
                                      },
                                    ],
                                  }
                                ),
                                dimensions.width
                              )}
                            />
                            <View
                              style={StyleSheet.applyWidth(
                                { paddingTop: 20 },
                                dimensions.width
                              )}
                            >
                              <Utils.CustomCodeErrorBoundary>
                                <BarChartMobile.App />
                              </Utils.CustomCodeErrorBoundary>
                            </View>
                          </View>
                          {/* Widget */}
                          <View
                            style={StyleSheet.applyWidth(
                              { flex: 1.8, gap: 20, justifyContent: 'center' },
                              dimensions.width
                            )}
                          >
                            {/* Top */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  flexDirection: 'row',
                                  justifyContent: 'space-around',
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                  width: '100%',
                                },
                                dimensions.width
                              )}
                            >
                              {/* Starting Balance View */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor:
                                      palettes.Brand['App Green'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    height: (dimensions.width - 60) / 2.2,
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: palettes.Brand.Black,
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Starting Balance'}
                                </Text>
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(
                                    Images['startingbalance']
                                  )}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {Constants['STARTING_CASH']
                                    ? formatNumber(Constants['STARTING_CASH'])
                                    : formatNumber(0)}
                                </Text>
                              </View>
                              {/* Ending Balance View */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor:
                                      palettes.Brand['App Blue Dark'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Ending Balance'}
                                </Text>
                                {/* Image 2 */}
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(Images['endingbalance'])}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {formatNumber(
                                    Constants['TOTAL_CASH_ON_HAND'] &&
                                      Constants['TOTAL_CASH_ON_HAND'][11]
                                  )}
                                </Text>
                              </View>
                            </View>
                            {/* Bottom */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  flexDirection: 'row',
                                  justifyContent: 'space-around',
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                  width: '100%',
                                },
                                dimensions.width
                              )}
                            >
                              {/* Avg.Monthly Payroll */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor:
                                      palettes.Brand['App Blue Dark'],
                                    borderColor: palettes.Brand['App Green'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    borderWidth: 4,
                                    height: (dimensions.width - 60) / 2.2,
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Avg. Monthly'}
                                </Text>
                                {/* Head 2 */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 14,
                                        marginTop: -8,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Employee Expense'}
                                </Text>
                                {/* Image 2 */}
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(Images['payrol'])}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {formatNumber(
                                    calculateAverage(
                                      Constants['PAYROLL_EXPENSES']
                                    )
                                  )}
                                </Text>
                              </View>
                              {/* Avg. Monthly Operating Expense */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor: palettes.Brand.White,
                                    borderColor:
                                      palettes.Brand['App Blue Dark'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    borderWidth: 4,
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Avg. Monthly'}
                                </Text>
                                {/* Head 2 */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 14,
                                        marginTop: -8,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Operating Expense'}
                                </Text>
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(Images['operating'])}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {formatNumber(
                                    calculateAverage(
                                      Constants['OPERATING_EXPENSES']
                                    )
                                  )}
                                </Text>
                              </View>
                            </View>
                            {/* Bottom 2 */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  flexDirection: 'row',
                                  justifyContent: 'space-around',
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                  width: '100%',
                                },
                                dimensions.width
                              )}
                            >
                              {/* Avg. Monthly Product Expense */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor: palettes.Brand.White,
                                    borderColor:
                                      palettes.Brand['App Blue Dark'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    borderWidth: 4,
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Avg. Monthly'}
                                </Text>
                                {/* Head 2 */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.Black,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 14,
                                        marginTop: -8,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Product Costs'}
                                </Text>
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(Images['operating'])}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {formatNumber(
                                    calculateAverage(
                                      Constants['PRODUCT_PAYMENT_COSTS']
                                    )
                                  )}
                                </Text>
                              </View>
                              {/* Avg.Monthly Finance */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    backgroundColor:
                                      palettes.Brand['App Blue Dark'],
                                    borderColor: palettes.Brand['App Green'],
                                    borderRadius: [
                                      {
                                        minWidth: Breakpoints.Desktop,
                                        value: 12,
                                      },
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: 12,
                                      },
                                    ],
                                    borderWidth: 4,
                                    height: (dimensions.width - 60) / 2.2,
                                    justifyContent: 'space-evenly',
                                    width: (dimensions.width - 60) / 2.2,
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Head */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 16,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Avg. Monthly'}
                                </Text>
                                {/* Head 2 */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Widgets']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Widgets']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: palettes.Brand['App Green'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: 'OpenSans_600SemiBold',
                                        fontSize: 14,
                                        marginTop: -8,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Finance Expense'}
                                </Text>
                                {/* Image 2 */}
                                <Image
                                  resizeMode={'cover'}
                                  {...GlobalStyles.ImageStyles(theme)['Image']
                                    .props}
                                  source={imageSource(Images['payrol'])}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ImageStyles(theme)['Image']
                                        .style,
                                      {
                                        height: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                        width: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 50,
                                          },
                                          {
                                            minWidth: Breakpoints.BigScreen,
                                            value: 60,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: (dimensions.width - 60) / 6,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                />
                                {/* Values */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value:
                                              palettes.Brand['App Blue Dark'],
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: palettes.Brand.White,
                                          },
                                        ],
                                        fontFamily: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'OpenSans_500Medium',
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 'OpenSans_600SemiBold',
                                          },
                                        ],
                                        fontSize: [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 28,
                                          },
                                          {
                                            minWidth: Breakpoints.Mobile,
                                            value: 22,
                                          },
                                        ],
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$'}
                                  {formatNumber(
                                    calculateAverage(
                                      Constants['FINANCE_EXPENSES']
                                    )
                                  )}
                                </Text>
                              </View>
                            </View>
                          </View>
                        </SimpleStyleScrollView>
                      )}
                    </>
                    {/* Scroll View 3 */}
                    <>
                      {!selectedMonth ? null : (
                        <SimpleStyleScrollView
                          bounces={true}
                          horizontal={false}
                          keyboardShouldPersistTaps={'never'}
                          nestedScrollEnabled={false}
                          showsHorizontalScrollIndicator={true}
                          showsVerticalScrollIndicator={true}
                          style={StyleSheet.applyWidth(
                            { flex: 1 },
                            dimensions.width
                          )}
                        >
                          <DefaultApi.FetchDataForMobileGET
                            handlers={{
                              onData: fetchData => {
                                try {
                                  /* hidden 'Log to Console' action */
                                } catch (err) {
                                  console.error(err);
                                }
                              },
                            }}
                            selected_month={selectedMonth}
                          >
                            {({
                              loading,
                              error,
                              data,
                              refetchDataForMobile,
                            }) => {
                              const fetchData = data?.json;
                              if (loading) {
                                return (
                                  <>
                                    {/* isLoading View */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          alignItems: [
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            {
                                              minWidth: Breakpoints.Mobile,
                                              value: 'center',
                                            },
                                          ],
                                          backgroundColor: {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.App['Black %50'],
                                          },
                                          flex: [
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            {
                                              minWidth: Breakpoints.Mobile,
                                              value: 1,
                                            },
                                          ],
                                          gap: 10,
                                          justifyContent: [
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'center',
                                            },
                                            {
                                              minWidth: Breakpoints.Mobile,
                                              value: 'center',
                                            },
                                          ],
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      <ActivityIndicator
                                        animating={true}
                                        hidesWhenStopped={true}
                                        {...GlobalStyles.ActivityIndicatorStyles(
                                          theme
                                        )['Activity Indicator'].props}
                                        size={'large'}
                                        style={StyleSheet.applyWidth(
                                          StyleSheet.compose(
                                            GlobalStyles.ActivityIndicatorStyles(
                                              theme
                                            )['Activity Indicator'].style,
                                            {
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 100,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 100,
                                              },
                                            }
                                          ),
                                          dimensions.width
                                        )}
                                      />
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Header'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          StyleSheet.compose(
                                            GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].style,
                                            {
                                              color: palettes.Brand.White,
                                              fontSize: [
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 20,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 20,
                                                },
                                              ],
                                            }
                                          ),
                                          dimensions.width
                                        )}
                                      >
                                        {'Loading, please wait...'}
                                      </Text>
                                    </View>
                                  </>
                                );
                              }

                              if (
                                error ||
                                data?.status < 200 ||
                                data?.status >= 300
                              ) {
                                return <ActivityIndicator />;
                              }

                              return (
                                <>
                                  {/* MonthlyDashboard */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      { flex: 6 },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Widget */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          flex: 1.8,
                                          gap: 20,
                                          justifyContent: 'space-evenly',
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Top */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: 'row',
                                            justifyContent: 'space-around',
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            width: '100%',
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Starting Balance View */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand['App Green'],
                                              borderColor:
                                                palettes.Brand['App Blue Dark'],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              height:
                                                (dimensions.width - 60) / 2.2,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: palettes.Brand.Black,
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Starting Balance'}
                                          </Text>
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['startingbalance']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values 2 */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.Black,
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              fetchData?.starting_balance
                                                ?.amount
                                                ? fetchData?.starting_balance
                                                    ?.amount
                                                : 0
                                            )}
                                          </Text>
                                        </View>
                                        {/* Forecast Sales */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand['App Purple'],
                                              borderColor:
                                                palettes.Brand['App Orange'],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Forecast Income'}
                                          </Text>
                                          {/* Image 2 */}
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['endingbalance']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              fetchData?.income?.[0]
                                                ?.monthly_income_amount
                                                ? fetchData?.income?.[0]
                                                    ?.monthly_income_amount
                                                : 0
                                            )}
                                          </Text>
                                        </View>
                                      </View>
                                      {/* Middile */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: 'row',
                                            justifyContent: 'space-around',
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            width: '100%',
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Monthly Payroll */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand['App Blue Dark'],
                                              borderColor:
                                                palettes.Brand['App Green'],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              height:
                                                (dimensions.width - 60) / 2.2,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Monthly'}
                                          </Text>
                                          {/* Head 2 */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 14,
                                                  marginTop: -8,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Employee Expense'}
                                          </Text>
                                          {/* Image 2 */}
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['payrol']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              fetchData?.payroll_expenses?.[0]
                                                ?.monthly_expenses_amount
                                                ? fetchData
                                                    ?.payroll_expenses?.[0]
                                                    ?.monthly_expenses_amount
                                                : 0
                                            )}
                                          </Text>
                                        </View>
                                        {/* Monthly Product Costs */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand['App Pink'],
                                              borderColor: palettes.Brand.Black,
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              height:
                                                (dimensions.width - 60) / 2.2,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Monthly'}
                                          </Text>
                                          {/* Head 2 */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 14,
                                                  marginTop: -8,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Product Costs'}
                                          </Text>
                                          {/* Image 2 */}
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['product']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              fetchData?.cogs?.[0]
                                                ?.monthly_expenses_amount
                                                ? fetchData?.cogs?.[0]
                                                    ?.monthly_expenses_amount
                                                : 0
                                            )}
                                          </Text>
                                        </View>
                                      </View>
                                      {/* Bottom */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: 'row',
                                            justifyContent: 'space-around',
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            width: '100%',
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Monthly Operating Expense */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand['App Orange'],
                                              borderColor:
                                                palettes.Brand['App Purple'],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              height:
                                                (dimensions.width - 60) / 2.2,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Monthly'}
                                          </Text>
                                          {/* Head 2 */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 14,
                                                  marginTop: -8,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Operating Expense'}
                                          </Text>
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['operating']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              fetchData?.operating_expenses?.[0]
                                                ?.monthly_expenses_amount
                                                ? fetchData
                                                    ?.operating_expenses?.[0]
                                                    ?.monthly_expenses_amount
                                                : 0
                                            )}
                                          </Text>
                                        </View>
                                        {/* Ending Balance */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: 'center',
                                              backgroundColor:
                                                palettes.Brand.White,
                                              borderColor:
                                                palettes.Brand['App Blue Dark'],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 12,
                                                },
                                                {
                                                  minWidth: Breakpoints.Mobile,
                                                  value: 12,
                                                },
                                              ],
                                              borderWidth: 4,
                                              justifyContent: 'space-evenly',
                                              width:
                                                (dimensions.width - 60) / 2.2,
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Head */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Widgets'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Widgets'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Green'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand.Black,
                                                    },
                                                  ],
                                                  fontFamily:
                                                    'OpenSans_600SemiBold',
                                                  fontSize: 16,
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Ending Balance'}
                                          </Text>
                                          <Image
                                            resizeMode={'cover'}
                                            {...GlobalStyles.ImageStyles(theme)[
                                              'Image'
                                            ].props}
                                            source={imageSource(
                                              Images['endingbalance']
                                            )}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.ImageStyles(theme)[
                                                  'Image'
                                                ].style,
                                                {
                                                  height: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                  width: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 50,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.BigScreen,
                                                      value: 60,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        (dimensions.width -
                                                          60) /
                                                        6,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          />
                                          {/* Values */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ],
                                                    },
                                                  ],
                                                  fontFamily: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value:
                                                        'OpenSans_500Medium',
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value:
                                                        'OpenSans_600SemiBold',
                                                    },
                                                  ],
                                                  fontSize: [
                                                    {
                                                      minWidth:
                                                        Breakpoints.Desktop,
                                                      value: 28,
                                                    },
                                                    {
                                                      minWidth:
                                                        Breakpoints.Mobile,
                                                      value: 22,
                                                    },
                                                  ],
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {formatNumber(
                                              calculateEndingBalance(fetchData)
                                            )}
                                          </Text>
                                        </View>
                                      </View>
                                    </View>
                                  </View>
                                </>
                              );
                            }}
                          </DefaultApi.FetchDataForMobileGET>
                        </SimpleStyleScrollView>
                      )}
                    </>
                    {/* Picker */}
                    <View
                      style={StyleSheet.applyWidth(
                        {
                          backgroundColor: palettes.Brand.Black,
                          marginBottom: 20,
                          marginTop: 20,
                        },
                        dimensions.width
                      )}
                    >
                      <>
                        {selectedMonth ? null : (
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignSelf: 'center',
                                position: 'absolute',
                                top: 20,
                                zIndex: 0,
                              },
                              dimensions.width
                            )}
                          >
                            {/* Select Month Text */}
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    color: palettes.Brand.White,
                                    fontFamily: 'OpenSans_500Medium',
                                    textAlign: 'center',
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {'Select Month'}
                            </Text>
                          </View>
                        )}
                      </>
                      <DatePicker
                        autoDismissKeyboard={true}
                        disabled={false}
                        inline={false}
                        leftIconMode={'inset'}
                        mode={'date'}
                        onDateChange={newDatePickerValue => {
                          const datePickerValue = newDatePickerValue;
                          try {
                            setSelectedMonth(newDatePickerValue);
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                        borderColorActive={palettes.Brand.Black}
                        defaultValue={selectedMonth}
                        format={'mmm yyyy'}
                        hideLabel={true}
                        label={''}
                        labelColor={palettes.Brand.White}
                        style={StyleSheet.applyWidth(
                          {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            color: palettes.Brand.White,
                            fontFamily: 'OpenSans_500Medium',
                            textAlign: 'center',
                            zIndex: 10,
                          },
                          dimensions.width
                        )}
                        type={'solid'}
                      />
                    </View>
                  </View>
                )}
              </>
              <Modal
                animationType={'none'}
                supportedOrientations={['portrait', 'landscape']}
                transparent={true}
                visible={visibleWhatIf}
              >
                <BlurView
                  intensity={50}
                  tint={'default'}
                  {...GlobalStyles.BlurViewStyles(theme)['Scenario Blur'].props}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.BlurViewStyles(theme)['Scenario Blur'].style,
                    dimensions.width
                  )}
                >
                  <ScenarioBlock
                    setVisibleWhatIf={visibleWhatIf =>
                      setVisibleWhatIf(visibleWhatIf)
                    }
                    visibleWhatIf={visibleWhatIf}
                  />
                </BlurView>
              </Modal>
            </>
          );
        }}
      </DefaultApi.FetchDashboardDataGET>
    </ScreenContainer>
  );
};

export default withTheme(DashboardScreen);
